import { Col } from 'antd';
import { toast } from 'react-toastify';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import CopyCode from 'v3/components/CopyCode';
import IconItem from 'v3/components/IconItem';
import StoresButton from 'v3/components/StoresButton';
import AccessPanel from './AccessPanel';

import ReactGA from 'react-ga';
import { isProduction } from '../../utils/checkEnv';
import { useMixpanel } from 'v3/hooks/useMixpanel';

import extraPaymentSvg from 'v3/assets/svg/extra-payments.svg';
import rankingSvg from 'v3/assets/svg/ranking.svg';
import savingsCoinsSvg from 'v3/assets/svg/savings-coins.svg';
import savingsScoreSvg from 'v3/assets/svg/savings-score.svg';
import savingsPigSvg from 'v3/assets/svg/savings-pig.svg';
import thumbsUpSvg from 'v3/assets/svg/thumbs-up.svg';
import QRCode from 'v3/assets/images/qr-code.png';
import screenHome from 'v3/assets/images/screen-home.png';
import screenVoucher from 'v3/assets/images/screen-voucher.png';

import * as S from './styles';
import * as SS from './successStyles';
import logoWhite from 'v3/assets/svg/logo-white.svg';

const IOS_STORE_LINK =
  'https://apps.apple.com/us/app/savings-club/id1610561338';
const ANDROID_STORE_LINK =
  'https://play.google.com/store/apps/details?id=club.savings';

const Welcome = () => {
  const { leadData, firstTimeToken } = useSelector(
    (state: RootState) => state.lead
  );
  const mp = useMixpanel();

  const code = firstTimeToken.length ? firstTimeToken : leadData.firstTimeToken;

  const copyToClipboard = () => {
    void navigator.clipboard.writeText(code);
    toast.success('Copied');
  };

  useEffect(() => {
    if (!leadData.firstName) {
      window.location.href = 'https://contractflow.savings.club/deals/';
    }

    const isProd = isProduction();
    if (isProd) {
      ReactGA.ga('event', 'conversion', {
        send_to: 'AW-10885163566/4hlpCPvEnqEYEK7UucYo',
      });
    }

    mp.fireAccessWelcome();
  }, [leadData.firstName]);

  return (
    <SS.Overlay>
      <SS.Aura aria-hidden />
      <a href="https://savings.club" aria-label="Savings.Club home">
        <SS.Logo src={logoWhite} alt="Savings.Club" />
      </a>

      <SS.Center>
        <SS.Win>
          It&apos;s official{leadData.firstName ? `, ${leadData.firstName}` : ''}!
        </SS.Win>
        <SS.Headline>
          <span className="lead">You&apos;re in.</span>{' '}
          <span className="rest">Welcome to the club.</span>
        </SS.Headline>
        <SS.Subline>Everything happens in the app now.</SS.Subline>

        <AccessPanel
          code={code}
          hasPassword={leadData.hasPassword}
          onCopy={copyToClipboard}
        />

        <SS.Handoff>
          <SS.QRBlock>
            <SS.Label>Scan with your phone</SS.Label>
            <SS.QRCard>
              <img src={QRCode} alt="Scan to download the Savings Club app" />
            </SS.QRCard>
          </SS.QRBlock>

          <SS.PhoneBlock>
            <img src={screenHome} alt="" aria-hidden />
            <img
              src={screenVoucher}
              alt="The app: your position and Savings Score among your club"
            />
          </SS.PhoneBlock>

          <SS.BadgesBlock>
            <SS.Label>Get the app</SS.Label>
            <SS.Badges>
              <StoresButton platform="ios" link={IOS_STORE_LINK} />
              <StoresButton platform="android" link={ANDROID_STORE_LINK} />
            </SS.Badges>
          </SS.BadgesBlock>
        </SS.Handoff>
      </SS.Center>
    </SS.Overlay>
  );
};

export default Welcome;
